import { ComparedItem } from "../../../models/comparison_table/comparison_table";

// 項目毎の区切り文字
const COLUMN_SPLIT_CHARACTER = "-";
// アスクル品のサプライヤID
const SUPPLIER_ID_ASKUL = 'P00001';

export class ComparisonTableContainer {
  constructor(comparedItems: ComparedItem[]) {

    const comparedItemsToShow = comparedItems.map(item => {
      const itemKeySplit = item.itemKey.split(COLUMN_SPLIT_CHARACTER);
      const supplierId = itemKeySplit[0];
      const catalogItemCode = itemKeySplit[1];
  
      return {
          variationCode: item.itemDetail.variationCode,
          code: item.itemKey,
          href: supplierId === SUPPLIER_ID_ASKUL ? `/p/${catalogItemCode}/` : `/p/${supplierId}-${catalogItemCode}/`,
          imgSrc: item.itemDetail.imageUrl,
          priceStr: item.itemDetail.price,
          text: item.itemDetail.name
      }
    });

    // デザイン側JSを呼出し、追従パーツを表示する。
    (window as any).BottomTrackingAddComparison.addSelectedArray(comparedItemsToShow);
  }  
}
